import type { AdSetEntry } from '../api/getAdSets';

export const isDuplicatesCounts = (rows: AdSetEntry | undefined): rows is AdSetEntry & Pick<AdSetEntry, 'duplicates_count'> =>
  !!rows && 'duplicates_count' in rows;